// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
}
.layout {
  background-color: #fff;
  display: grid;
  grid-template-columns: [sidebar] 320px [client] 1fr;
  grid-template-rows: [client] 1fr;
  height: 100vh;
  overflow: hidden;
}
.layout-sidebar {
  background: var(--default-bg);
  border-right: 1px solid #d8dbdf;
  grid-column: 1/sidebar;
  grid-row: 1/end;
  overflow-y: auto;
}
.layout-menu {
  border-bottom: 1px solid var(--default-surface-border);
  grid-column: client/end;
  grid-row: 1/breadcrumb;
}
.layout-breadcrumb {
  border-bottom: 1px solid var(--default-surface-border);
  grid-column: client/end;
  grid-row: breadcrumb/client;
}
.layout-main {
  grid-column: client/end;
  grid-row: client/end;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./../../../../packages/client/src/core-components/layouts/default.vue"],"names":[],"mappings":"AAGE;EACE,SAAA;AAFJ;AAIE;EACE,sBAAA;EACA,aAAA;EACA,mDAAA;EACA,gCAAA;EACA,aAAA;EACA,gBAAA;AADJ;AAGE;EACE,6BAAA;EACA,+BAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AAEE;EAEE,sDAAA;EACA,uBAAA;EACA,sBAAA;AAAJ;AAEE;EAEE,sDAAA;EACA,uBAAA;EACA,2BAAA;AAAJ;AAEE;EACE,uBAAA;EACA,oBAAA;EACA,cAAA;AACJ","sourcesContent":["\n  @use '@wholebodyapp/design/colors/palette' as *;\n\n  body {\n    margin: 0;\n  }\n  .layout {\n    background-color: #fff;\n    display: grid;\n    grid-template-columns: [sidebar] 320px [client] 1fr;\n    grid-template-rows: [client] 1fr;\n    height: 100vh;\n    overflow: hidden;\n  }\n  .layout-sidebar {\n    background: var(--default-bg);\n    border-right: 1px solid $gray-200;\n    grid-column: 1 / sidebar;\n    grid-row:  1  / end;\n    overflow-y: auto;\n  }\n  .layout-menu {\n    // background-color: rgba(200, 0, 0, 0.25);\n    border-bottom: 1px solid var(--default-surface-border);\n    grid-column: client / end;\n    grid-row: 1 / breadcrumb;\n  }\n  .layout-breadcrumb {\n    // background-color: rgba(0, 200, 0, 0.25);\n    border-bottom: 1px solid var(--default-surface-border);\n    grid-column: client / end;\n    grid-row: breadcrumb / client;\n  }\n  .layout-main {\n    grid-column: client / end;\n    grid-row: client / end;\n    overflow: auto;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
